import React, { useEffect, useState } from 'react';
import axios from 'axios';
import FacultyView from '../../components/SuperAdmin/FacultyView';

function Faculty() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(()=>{
    try{
      const fetchData = async () => {
        const result = await axios.post(`${process.env.REACT_APP_BASE_URL}/admin/get-all-users`, {type: "faculty"}, {withCredentials: true});
        setData(result.data.users);
      }
      fetchData();
      setLoading(false);
    }catch(e){
      console.log(e);
      setLoading(false);
    }
  }, []);
  if(loading) return <p>Loading...</p>
  return (
    <div className="p-8">
      <h1 className="text-2xl font-semibold mb-6 ml-5">Admin Dashboard</h1>
      <FacultyView title={"Faculty"} data={data} />
    </div>
  )
}

export default Faculty